/** Reusable static yard details: straw, drying leaves and bound cargo. */
import { el, n } from '../../svg';
import type { ResolvedPalette } from '../../contract';
import { line, rivet } from './machinerySvg';
export function herbBundle(x: number, y: number, length: number, random: (key: string) => number, key: string, p: ResolvedPalette): string {
  let art = '';
  for (let i = 0; i < 5; i++) {
    const tipX = x + (i - 2) * 3.1, tipY = y + length - random(`${key}.length.${i}`) * 7;
    art += line(x, y, tipX, tipY, p.reedShadow, 1);
    for (let j = 0; j < 4; j++) {
      const sy = y + 6 + (tipY - y - 8) * j / 4, sx = x + (tipX - x) * (sy - y) / (tipY - y);
      const side = (i + j) % 2 ? 1 : -1;
      art += el('path', { d: `M${n(sx)} ${n(sy)}Q${n(sx + side * 8)} ${n(sy - 1)} ${n(sx + side * 5)} ${n(sy + 7)}Q${n(sx + side * 1)} ${n(sy + 6)} ${n(sx)} ${n(sy)}Z`, fill: j % 2 ? p.reedBase : p.moss, stroke: p.reedShadow, 'stroke-width': 0.45 });
    }
  }
  return art + line(x - 3, y + 2, x + 3, y + 2, p.paperBase, 2.5);
}
export function crate(x: number, y: number, size: number, p: ResolvedPalette): string {
  let art = el('path', { d: `M${x} ${y}H${x + size}V${y + size}H${x}Z`, fill: p.woodBase, stroke: p.outline, 'stroke-width': 1.2 })
    + el('path', { d: `M${x} ${y}L${x + 4} ${y - 4}H${x + size + 4}L${x + size} ${y}Z`, fill: p.woodLight, stroke: p.outline, 'stroke-width': 0.8 })
    + el('path', { d: `M${x + size} ${y}L${x + size + 4} ${y - 4}V${y + size - 4}L${x + size} ${y + size}Z`, fill: p.woodShadow, stroke: p.outline, 'stroke-width': 0.8 });
  for (let i = 1; i < 4; i++) art += line(x + size * i / 4, y + 2, x + size * i / 4, y + size - 2, p.woodShadow, 0.8);
  art += line(x + 3, y + 3, x + size - 3, y + size - 3, p.woodLight, 4)
    + line(x + 3, y + size - 3, x + size - 3, y + 3, p.woodLight, 4);
  return art + rivet(x + 3, y + 3, p, 1) + rivet(x + size - 3, y + size - 3, p, 1);
}
